<template>
  <div class="main-container">
    <div class="team-experiences-page">
      <h1 class="main-title">Life at Travvir</h1>
      <div class="content-grid">
        <div
          class="content-block"
          v-for="(item, index) in InfoFirstArray"
          :key="index"
        >
          <h2>{{ item.Heading }}</h2>
          <p>
            <i>{{ item.SubHeading }}</i>
          </p>
        </div>
      </div>
    </div>
    <!-- img -->
    <ourTeam />
    <div class="values-page">
      <h1 class="main-title">Our Values</h1>
      <div class="content-grid">
        <div
          class="value-block"
          v-for="text in InfoSecondArray"
          :key="text.Heading"
        >
          <h2>{{ text.Heading }}</h2>
          <p>
            <i>{{ text.SubHeading }}</i>
          </p>
        </div>
      </div>
    </div>
    <div class="team-experiences-page1">
      <!-- Hero Section -->
      <!-- Team Gallery Section -->
      <div class="team-gallery">
        <div class="gallery-grid">
          <div class="gallery-item center">
            <NuxtImg
              width="400px"
              height="400px"
              :src="baseUrl + `rohan3.jpg`"
              alt="Team collaboration"
            />
          </div>
          <div class="gallery-item top-left">
            <NuxtImg
              width="400px"
              height="400px"
              :src="baseUrl + `travvir-group.jpg`"
              alt="Team meeting"
            />
          </div>
          <div class="gallery-item top-right">
            <NuxtImg
              width="400px"
              height="400px"
              :src="baseUrl + `travvir-group1.jpg`"
              alt="Team celebration"
            />
          </div>
          <div class="gallery-item bottom-left">
            <NuxtImg
              width="400px"
              height="400px"
              :src="baseUrl + `priyam1.jpg`"
              alt="Team member"
            />
          </div>
          <div class="gallery-item bottom-right">
            <NuxtImg
              width="400px"
              height="400px"
              :src="baseUrl + `rupesh1.jpg`"
              alt="Team outing"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRuntimeConfig } from "nuxt/app";
const InfoFirstArray = [
  {
    Heading: "Team Moments",
    SubHeading:
      "Every team creates special experiences that inspire collaboration and connection.",
  },
  {
    Heading: "Celebrations",
    SubHeading:
      "From milestones to festivals, Travvir celebrations keep the energy high and strengthen our bonds.",
  },
  {
    Heading: "Shared Experiences",
    SubHeading:
      "Each month, we host engaging, family-friendly activities that make everyone feel included.",
  },
  {
    Heading: "Travvir Retreats",
    SubHeading:
      "Our annual retreats take us to stunning destinations, creating memories that last a lifetime.",
  },
];
const InfoSecondArray = [
  {
    Heading: "Ambition",
    SubHeading:
      "We set bold goals and push the boundaries of what’s possible in spatial AI, always striving to redefine digital exploration.",
  },
  {
    Heading: "Courage",
    SubHeading:
      "We embrace challenges and make decisions that drive meaningful progress.",
  },
  {
    Heading: "Dedication",
    SubHeading:
      "We are committed to excellence in transforming smartphone captures into immersive worlds.",
  },
  {
    Heading: "Long-Term Vision",
    SubHeading:
      "We build technology that shapes the future of digital place experiences.",
  },
  {
    Heading: "Optimism",
    SubHeading:
      "We believe in AI’s power to make the world more accessible and connected.",
  },
  {
    Heading: "Ownership",
    SubHeading:
      "We take responsibility and initiative to drive our mission forward.",
  },
  {
    Heading: "Innovation",
    SubHeading:
      "We constantly explore new possibilities in spatial intelligence and AI technology.",
  },
  {
    Heading: "Collaboration",
    SubHeading:
      "We work together to create solutions that democratize digital exploration.",
  },
];

const config = useRuntimeConfig();
const baseUrl = config.public.NUXT_CDN_URL + `/static/website/`;
import OurTeam from "./OurTeam.vue";
</script>
<style lang="scss" scoped>
.main-container {
  background: #000;
  color: #fff;
  margin-top: 2rem;
  padding: 2rem 1.5rem;
  // font-family: "Book21", "Sharp Grotesk", sans-serif;
  font-family: "Inter", "Helvetica Neue", sans-serif;
  @include respond-below(lg) {
    padding: 0rem;
  }
}
.main-title {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0rem 2rem;
  text-align: start;
  // font-size: clamp(30px, 8vw, 85px);
  // margin-bottom: 2.5rem;
  // letter-spacing: -1px;
  font-size: clamp(2rem, 3vw, 2.7rem);
  font-weight: 500;
  font-style: italic;
  margin-bottom: 1.5rem;
  background-image: linear-gradient(
    90deg,
    #fff 1.51%,
    #5d5be6 18.01%,
    #fff 82.09%
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  @include respond-below(sm) {
    padding: 0rem 1rem;
    font-size: clamp(30px, 10vw, 60px);
    margin-bottom: 1.5rem;
  }
}
.team-experiences-page {
  margin-top: 3rem;
  background: #000;
  color: #fff;
  height: fit-content;
  margin-bottom: 3.5rem;
}

.content-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 4rem 6rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 2rem 6rem;

  @include respond-below(lg) {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 3rem 4rem;
  }

  @include respond-below(md) {
    grid-template-columns: 1fr;
    gap: 3rem;
    padding: 2rem 1.5rem 4rem;
  }

  @include respond-below(sm) {
    grid-template-columns: 1fr;
    gap: 2.5rem;
    padding: 1.5rem 1rem 3rem;
  }
}
h2 {
  text-decoration: none;
  font-size: 1.6rem;
  font-weight: 500;
  margin-bottom: 0.15rem;
  color: #ffffff;
  @include respond-below(lg) {
    font-size: 1.8rem;
    margin-bottom: 0.75rem;
  }
  @include respond-below(sm) {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }
}
p {
  // font-style: italic;
  font-size: clamp(1.01rem, 2.5vw, 1.2rem);
  line-height: 1.4;
  color: #999999;
  margin: 0;

  @include respond-below(lg) {
    width: 100%;
    font-size: 1.1rem;
  }
  @include respond-below(md) {
    font-size: 1.01rem;
    line-height: 1.5;
  }
}

.team-experiences-page1 {
  background: #000;
  color: #fff;
  min-height: fit-content;
  @include respond-below(sm) {
  }
}
.team-gallery {
  padding: 4rem 2rem 6rem;
  max-width: 1400px;
  margin: 0 auto;

  @include respond-below(md) {
    padding: 3rem 1.5rem 4rem;
  }

  @include respond-below(sm) {
    padding: 2rem 1rem 3rem;
  }
}

.gallery-grid {
  position: relative;
  width: 100%;
  height: fit-content;
  min-height: 850px;

  @include respond-below(lg) {
    height: 85vh;
    min-height: 540px;
  }

  @include respond-below(md) {
    height: 79vh;
    min-height: 490px;
  }

  @include respond-below(sm) {
    height: 60vh;
    min-height: 440px;
  }
}

.gallery-item {
  position: absolute;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  &.center {
    top: 37%;
    left: 50%;
    transform: translate(-50%, -37%);
    width: clamp(300px, 35vw, 475px);
    height: clamp(calc(200px / 1.33), 26vw, calc(450px / 1.33));
    z-index: 4;

    @include respond-below(lg) {
      top: 40%;
      width: clamp(280px, 40vw, 420px);
      height: clamp(180px, 28vw, 290px);
    }

    @include respond-below(md) {
      width: clamp(250px, 45vw, 350px);
      height: clamp(160px, 32vw, 280px);
    }

    @include respond-below(sm) {
      top: 45%;
      width: clamp(200px, 46vw, 280px);
      height: clamp(150px, 35vw, 190px);
    }
  }

  &.top-left {
    top: 5%;
    left: 7%;
    width: clamp(280px, 32vw, 420px);
    height: clamp(calc(200px / 1.33), 25vw, calc(380px / 1.33));
    z-index: 2;

    @include respond-below(lg) {
      top: 0;
      width: clamp(260px, 35vw, 370px);
      height: clamp(170px, 25vw, 270px);
    }

    @include respond-below(md) {
      width: clamp(220px, 40vw, 300px);
      height: clamp(140px, 28vw, 260px);
      left: 5%;
    }

    @include respond-below(sm) {
      width: clamp(150px, 45vw, 240px);
      height: clamp(120px, 32vw, 170px);
      left: 1%;
    }
  }

  &.top-right {
    top: 5%;
    right: 0;
    width: clamp(200px, 22vw, 300px);
    height: clamp(calc(260px / 1.33), 30vw, calc(400px / 0.75));
    z-index: 4;

    @include respond-below(lg) {
      width: clamp(180px, 25vw, 270px);
      height: clamp(230px, 32vw, 350px);
      right: 0%;
    }

    @include respond-below(md) {
      width: clamp(160px, 28vw, 200px);
      height: clamp(200px, 35vw, 280px);
      right: 0%;
    }

    @include respond-below(sm) {
      top: 0;
      width: clamp(130px, 32vw, 180px);
      height: clamp(170px, 40vw, 230px);
      right: 0;
    }
  }

  &.bottom-left {
    bottom: 7%;
    left: 11%;
    width: clamp(220px, 26vw, 340px);
    height: clamp(calc(220px / 1), 26vw, calc(340px / 1));
    z-index: 1;

    @include respond-below(lg) {
      width: clamp(200px, 28vw, 300px);
      height: clamp(200px, 28vw, 300px);
      left: 10%;
      bottom: 4%;
    }

    @include respond-below(md) {
      width: clamp(180px, 32vw, 250px);
      height: clamp(180px, 32vw, 250px);
      left: 5%;
      bottom: 7%;
    }

    @include respond-below(sm) {
      width: clamp(140px, 38vw, 200px);
      height: clamp(140px, 38vw, 200px);
      left: 0%;
      bottom: 1%;
    }
  }

  &.bottom-right {
    bottom: 0%;
    right: 7%;
    width: clamp(280px, 32vw, 420px);
    height: clamp(calc(180px / 1.33), 23vw, calc(350px / 1.33));
    z-index: 1;

    @include respond-below(lg) {
      width: clamp(260px, 35vw, 370px);
      height: clamp(160px, 25vw, 250px);
      right: 5%;
    }

    @include respond-below(md) {
      width: clamp(220px, 40vw, 300px);
      height: clamp(140px, 28vw, 200px);
      right: 4%;
      bottom: 10%;
    }

    @include respond-below(sm) {
      width: clamp(110px, 45vw, 240px);
      height: clamp(120px, 32vw, 160px);
      right: 0%;
      bottom: 2%;
    }
  }
}
</style>
